import type { ImportRowStatus } from '@obraplan/core/application/contracts/purchase-lines';
import { plural } from './purchase-model';

/**
 * O que as duas conferências — a das linhas de compra e a da mão de obra — repetem e que não
 * é tela: o tom de cada situação, o tamanho da tabela, o filtro e as frases de contagem.
 */

/** Quantos nomes a lista mostra antes do "e mais N". */
const LISTED = 12;

export function listed(names: readonly string[], limit = LISTED): string {
  const head = names.slice(0, limit).join(', ');
  return names.length > limit ? `${head} e mais ${String(names.length - limit)}` : head;
}

export const STATUS_TONE: Readonly<Record<ImportRowStatus, 'ok' | 'info' | 'neutral' | 'danger'>> =
  {
    CREATE: 'ok',
    UPDATE: 'info',
    UNCHANGED: 'neutral',
    ERROR: 'danger',
  };

/** Linhas que a tabela mostra de uma vez: o resto fica atrás do filtro. */
export const VISIBLE_LINES = 200;

export type StatusFilter = ImportRowStatus | 'ALL';

/** "3 linhas com erro ficam de fora." / "1 linha com erro fica de fora." — para a confirmação. */
export function errorsLeftOut(count: number): string {
  return count === 1
    ? '1 linha com erro fica de fora.'
    : `${plural(count, 'linha', 'linhas')} com erro ficam de fora.`;
}
